import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

import { serializeMiscPurchaseOrderCreate } from './serialize';

/** POST `/srm/misc-purchase-order`。建立 DRAFT，不預先產生單號。 */
export async function createMiscPurchaseOrder(payload) {
  const { data: raw } = await request.post(
    '/srm/misc-purchase-order',
    serializeMiscPurchaseOrderCreate(payload),
  );
  return parseVer4DetailResponse(raw);
}
